/**
 * This mixin used for dictionary options
 */

import DictionaryOption from '@/components/dynamic-list-items/dictionary-options/DictionaryOption.vue'
// options
// todo: manual full mode for all options for SQL data types
// manual mode means that u can control DynamicListWrapper events not in the mixin
import Option from '@/utils/options/Option'
// new Option('Дублировать', 'duplicate', '', false, false, true),
const options = [new Option('Удалить', 'delete', 'borderTop', true, false, true)]
// component export
export default {
  options,
  components: {
    DictionaryOption
  }
}
